<template>
  <div class="read-item-alt" v-if="read" @click="handleClick">
    <div class="colored-frame" :style="`background-color: ${read.color ? read.color : '#75FA90'};`">
      <img v-if="previewImage" :src="previewImage" alt="Read Image" class="read-image">
    </div>
    <div class="read-info">
      <div class="read-title">{{ read.title }}</div>
      <div class="read-category">{{ Array.isArray(read.tag) ? read.tag[0]?.title || '' : read.tag?.title }}</div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { defineProps, ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';

const router = useRouter();

const props = defineProps({
  read: {
    type: Object,
    required: true
  }
});

const previewImage = ref(props.read?.coverImage || '');

onMounted(() => {
  previewImage.value = props.read?.coverImage || '';
});

const handleClick = () => {
  router.push(`/reads/${props.read.slug}`);
  // Add your click handling logic here
};
</script>

<style scoped>
.read-item-alt {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}

.colored-frame {
  width: 100%;
  aspect-ratio: 325/415;
  padding: 20px;
  border-radius: 10px;
  overflow: hidden;
}

.read-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.read-info {
  padding: 20px 0;
}

.read-title {
  font-size: 20px;
  font-weight: 400;
  line-height: 1;
  margin-bottom: 10px;
}

.read-category {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.7);
}

@media (max-width: 480px) {

  .colored-frame {
    padding: 10px;
  }
  .read-info {
    padding: 8px 0;
  }
  .read-title {
    font-size: 10px;
    margin-bottom: 6px;
  }
  .read-category {
    font-size: 8px;
  }
  

}
</style>
